import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Modal,
  Card,
  CardHeader,
  CardActions,
  Divider,
  Button,
  CardContent,
  TableRow,
  TableCell,
  TableBody,
  Table,
  TableHead
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  labelCell: {
    whiteSpace: 'nowrap'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

function ProductionLogModal({
  open,
  onClose,
  className,
  productionLog,
  ...rest
}) {
  const classes = useStyles();

  if (!open && !productionLog) {
    return null;
  }

  const dollarAmount = value => {
    const number = parseFloat(value);
    if (isNaN(number)) return '$0.00';

    return number.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  return (
    <Modal onClose={onClose} open={open}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <CardHeader
          title={`Production Log for ${productionLog.carrier} Claim #${productionLog.claim_number}`}
        />
        <Divider />
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.labelCell}>Custom Name</TableCell>
              <TableCell>{productionLog.customer_name}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.labelCell}>Parts Amount</TableCell>
              <TableCell>{dollarAmount(productionLog.parts_amount)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.labelCell}>
                Body Labor Amount
              </TableCell>
              <TableCell>
                {dollarAmount(productionLog.body_labor_amount)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.labelCell}>
                Paint Labor Amount
              </TableCell>
              <TableCell>
                {dollarAmount(productionLog.paint_labor_amount)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.labelCell}>
                Paint Supplies Amount
              </TableCell>
              <TableCell>
                {dollarAmount(productionLog.paint_supplies_amount)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.labelCell}>PDR Amount</TableCell>
              <TableCell>{dollarAmount(productionLog.pdr_amount)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.labelCell}>
                Repair Estimate Total
              </TableCell>
              <TableCell>
                {dollarAmount(productionLog.repair_estimate_total)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.labelCell}>
                Deductible Amount
              </TableCell>
              <TableCell>
                {dollarAmount(productionLog.deductible_amount)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.labelCell}>Misc Amount</TableCell>
              <TableCell>{dollarAmount(productionLog.misc_amount)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.labelCell}>
                Windshield Damage?
              </TableCell>
              <TableCell>
                {productionLog.windshield_damage === 'true' ? 'Yes' : 'No'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.labelCell}>
                Back Roof Glass Damage?
              </TableCell>
              <TableCell>
                {productionLog.back_roof_glass_damage === 'true' ? 'Yes' : 'No'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.labelCell}>
                ADAS Required?
              </TableCell>
              <TableCell>
                {productionLog.adas_required === 'true' ? 'Yes' : 'No'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.labelCell}>Grade Tech?</TableCell>
              <TableCell>
                {productionLog.grade_tech === 'true' ? 'Yes' : 'No'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.labelCell}>Grade</TableCell>
              <TableCell>{productionLog.grade}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.labelCell}>Notes</TableCell>
              <TableCell>{productionLog.sw_notes}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <CardActions className={classes.actions}>
          <Button onClick={onClose}>Close</Button>
        </CardActions>
      </Card>
    </Modal>
  );
}

ProductionLogModal.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  productionLog: PropTypes.object.isRequired
};

ProductionLogModal.defaultProps = {
  open: false,
  onClose: () => {}
};

export default ProductionLogModal;
